import { createStore, createEffect, createEvent } from 'effector';
import { $notificationStore } from '../notificationStore';
import { FileUtils } from '@shared/utils';
import { StatementsApi, type GenerateRewardsStatementsRequest } from '@shared/api';

const generateRewardsStatementsEffect = createEffect((request: GenerateRewardsStatementsRequest) => StatementsApi.generateRewardsStatements(request));
generateRewardsStatementsEffect.done.watch((result) => FileUtils.downloadFile(result.result));
const clearEvent = createEvent();

const $loadingStore = createStore<boolean>(false)
  .on(generateRewardsStatementsEffect.pending, (_, data) => data)
  .on(generateRewardsStatementsEffect.fail, () => false)
  .on(generateRewardsStatementsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(generateRewardsStatementsEffect, () => null)
  .on(generateRewardsStatementsEffect.fail, () => 'Something went wrong while generating Rewards Statements. Please try again.')
  .on(generateRewardsStatementsEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $generateRewardsStatementsStore = {
  events: {
    generateRewardsStatements: generateRewardsStatementsEffect,
    clear: clearEvent,
  },
  store: {
    loading: $loadingStore,
    error: $errorStore,
  },
};
